export const M_ACCOUNT_CARD_ADDED =
  'The card was successfully added to your account';

export const M_ORDER_UPDATED = 'Successfully updated the order';
export const M_ORDER_UPDATE_REQUESTED = 'Your request to update the order was successfully submitted.';
export const M_ORDER_CREATED = 'Your order has been created successfully';
export const M_ACCOUNT_UPDATED = 'Successfully updated your account details';
export const M_ACCOUNT_CARD_REMOVED = 'Your card has been successfully removed.';
export const M_DOCUMENT_UPLOAD = 'Successfully uploaded document to order';
export const M_WELCOME_SEARCHLIGHT = 'Registration completed successfully. Welcome to Searchlight.';
export const M_USER_INVITE_SENT = 'The account invitation was sent successfully.';
export const M_INVITE_RESPONSE_UPDATED = 'The invitation was successfully updated.';
export const M_CONNECT_SUCCESS = 'The provider was successfully connected.';
export const M_DISCONNECT_SUCCESS = 'The provider was successfully disconnected.';